import React, { useEffect, useRef } from "react";

import commaNumber from "comma-number";

import { RenderLink } from "./renderLink";
import { formatDate } from "../../../../../../formatDate";
import { useLocation } from "react-router-dom";

import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import "./style.scss";

function Slide1(props) {
  const location = useLocation();
  const mounted = useRef();

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (props.slideData?.length > 0) {
        props.getData({
          type: "table",
          title: "Open and closed",
          filter: {
            brands: props.filter.data.brands.map((brand) => brand.name),
            chains: props.filter.data.chains.map((chain) => chain.name),
            revCent: props.filter.data.revCent.map((revCent) => revCent.name),
            payType: props.filter.data.payType.map((payType) => payType.name),
            date: {
              start: props.filter.data.date.start,
              end: props.filter.data.date.end,
            },
          },
          body: [
            {
              head: [
                [
                  "Buisness name",
                  "Status",
                  "Session No.",
                  "Gross Sales",
                  "Discount",
                  "Net Sales",
                  "Customers",
                  "Checks",
                  "Date / Time",
                ],
              ],
              body: props.slideData?.map((value) => [
                value.restaurant_name,
                `${value.status == 0 ? "open" : "closed"}`,
                `${value.sesNo}`,
                `${value.sessionGrossSales || 0} ${value.currency}`,
                `${value.sessionDiscount || 0} ${value.currency}`,
                `${value.sessionNetSales || 0} ${value.currency}`,
                `${value.sessionCustomers || 0}`,
                `${value.sessionChecks || 0}`,
                `${formatDate.long(value.date)}`,
              ]),
            },
          ],
        });
      }
    }
  }, [props.export]);

  const columns = [
    {
      Header: "Business Name",
      accessor: "restaurant_name",
      filterMethod: (filter, row) => {
        if (filter.value === "all") {
          return true;
        }

        if (row[filter.id] === filter.value) {
          return row[filter.id];
        }
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">All</option>
            {[
              ...new Set(
                props?.slideData.map((table) => table.restaurant_name)
              ),
            ].map((name) => (
              <option value={name}>{name}</option>
            ))}
          </select>
        );
      },
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={row.value}
          />
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      filterMethod: (filter, row) => {
        if (filter.value === "all") {
          return true;
        }

        if (filter.value === "Open") {
          return row[filter.id] === 0;
        }

        if (filter.value === "Closed") {
          return row[filter.id] === 1;
        }
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
          >
            <option value="all">All</option>
            <option value="Open">Open</option>
            <option value="Closed">Closed</option>
          </select>
        );
      },

      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={
              <div className={"name"}>
                <div className={row.value ? "open" : ""} />
                {row.value ? "Closed" : "Open"}
              </div>
            }
          />
        );
      },
    },
    {
      Header: "Session No.",
      accessor: "sesNo",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={row.value}
          />
        );
      },
    },
    {
      Header: "Gross Sales",
      accessor: "sessionGrossSales",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={`${row?.original?.currency} ${commaNumber(
              row?.value?.toFixed(2) || 0
            )}`}
          />
        );
      },
    },
    {
      Header: "Discount",
      accessor: "sessionDiscount",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={`${row?.original?.currency} ${commaNumber(
              row?.value?.toFixed(2) || 0
            )}`}
          />
        );
      },
    },
    {
      Header: "Net Sales",
      accessor: "sessionNetSales",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={`${row?.original?.currency} ${commaNumber(
              row?.value?.toFixed(2) || 0
            )}`}
          />
        );
      },
    },
    {
      Header: "Customers",
      accessor: "sessionCustomers",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={`${commaNumber(row.value) || 0}`}
          />
        );
      },
    },
    {
      Header: "Checks",
      accessor: "sessionChecks",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={`${commaNumber(row.value) || 0}`}
          />
        );
      },
    },
    {
      Header: "Date / Time",
      accessor: "date",
      Cell: (row) => {
        return (
          <RenderLink
            location={location}
            data={row.row._original}
            value={formatDate.long(row.value)}
          />
        );
      },
    },
  ];

  return (
    <div>
      <ReactTable
        className={["-striped", "-highlight"].join(" ")}
        data={props.slideData}
        columns={columns}
        sortable
        filterable
        getTdProps={() => ({
          style: {
            textAlign: "center",
          },
        })}
      />
    </div>
  );
}

export default Slide1;
